import { apiPlugin, storyblokInit } from "@storyblok/react/rsc";

// Blocks
import Features from "@/blocks/features";

// Collections
import Page from "@/collections/page";

export const getStoryblokApi = storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
  components: {
    // Blocks
    features: Features,
    
    // Collections
    page: Page,
  },
  use: [apiPlugin],
});